import { useIntl } from 'react-intl';
import { Divider, Form } from 'antd';
import { PageProps } from '@/types/PageProps';
import TabContentWrapper from '@/components/_common/TabContentWrapper';
import { SaveButton } from '@/components/_common/Buttons';

import { useHistory } from 'react-router-dom';
import {
  deliveryMaterialDTO,
  ListStockPartsDeliveryData,
  ListStockPartsDeliveryDataSupport,
} from '@/core/domain/stock/DeliveryMaterial/DeliveryMaterial.types';
import { useDeliveryMaterial } from '@/core/domain/stock/DeliveryMaterial/DeliveryMaterial.hooks';
import { DateTimeFormat } from '@/utils/moment';
import SpaceForButton from '@/components/_common/SpaceForButtons';
import ButtonBack from '@/components/_common/ButtonBack';
import notificationError from '@/utils/functions/notificationError';
import { useState } from 'react';
import DeliveryMaterialForm from '@/components/Movements/ReturnOrDeliveryMaterial/DeliveryMaterialForm';

function DeliverMaterialCreatePage({ route }: PageProps) {
  const intl = useIntl();
  const history = useHistory();

  const [form] = Form.useForm<deliveryMaterialDTO>();

  const deliveredItemsForm = Form.useWatch('deliveredItems', form);

  const [deliveredItems, setDeliveredItems] = useState<
    ListStockPartsDeliveryData[]
  >([]);

  const deliveryMaterial = useDeliveryMaterial();

  function handlerItemSelect(parts: ListStockPartsDeliveryDataSupport[]) {
    return parts.map((part) => ({
      deliveredQuantity: part.deliveredQuantity,
      complementId: part.provided
        ? part.workOrderComplementId
        : part.complementId,
      complementItemId: part.provided ? part.workOrderItemId : undefined,
      consumableId: part.provided ? undefined : part.workOrderItemId,
      costPrice: part.costPrice ?? 0,
      subareaId: part.subArea?.id,
      workOrderItemId: part.workOrderItemId,
    }));
  }

  const handleDeliveryMaterial = async () => {
    try {
      const { deliveryDateMoment, ...formValues } = await form.validateFields();
      if (deliveredItemsForm.some((item) => item.deliveredQuantity === 0)) {
        return notificationError(null, {
          message: 'Atenção!',
          description:
            'Não é possível realizar a entrega com a quantidade zerada!',
        });
      }

      const obj: deliveryMaterialDTO = {
        ...formValues,
        deliveredItems: handlerItemSelect(
          deliveredItemsForm as ListStockPartsDeliveryDataSupport[],
        ),
        deliveryDate: deliveryDateMoment?.format(DateTimeFormat) ?? '',
        observations: formValues.observations ?? '',
      };

      const response = await deliveryMaterial.mutateAsync(obj);

      history.push(
        `/app/movements/deliveryOfMaterials/${response?.result?.id}/delivery`,
      );
    } catch (error) {}
  };

  return (
    <TabContentWrapper
      title={route.name}
      permissions={route.permissions}
      extra={
        <SaveButton
          type="primary"
          loading={deliveryMaterial.isLoading}
          disabled={!deliveredItems?.length}
          onClick={handleDeliveryMaterial}
        >
          {intl.formatMessage({
            id: 'deliveryOrReturnOfMaterials.create.confirmDelivery',
          })}
        </SaveButton>
      }
    >
      <DeliveryMaterialForm
        form={form}
        deliveredItems={deliveredItems}
        setDeliveredItems={setDeliveredItems}
      />

      <Divider />

      <SpaceForButton>
        <ButtonBack path="/app/movements/deliveryOfMaterials" />
      </SpaceForButton>
    </TabContentWrapper>
  );
}

export default DeliverMaterialCreatePage;
